import React, { lazy } from 'react';
import { Navigate, Outlet } from 'react-router-dom';

import DefaultLayout from 'layouts/DefaultLayout';
import { ROUTER } from 'constants';

const Sections = lazy(() => {
  return import('views/section/SectionListView');
});

const Section = lazy(() => {
  return import('views/section/SectionDetailListView');
});

const Participants = lazy(() => {
  return import('views/participant/ParticipantListView');
});

const Participant = lazy(() => {
  return import('views/participant/ParticipantDetailView');
});

const MaterialsSummary = lazy(() => {
  return import('views/reports/MaterialsSummaryView');
});

const UtilizationSummary = lazy(() => {
  return import('views/reports/UtilizationSummaryView');
});

const Error404 = lazy(() => {
  return import('views/errors/404');
});

const Error403 = lazy(() => {
  return import('views/errors/403');
});

const basename = ROUTER.basename;

const routes = [
  {
    path: '*',
    element: <Navigate to={basename} replace />,
  },
  {
    path: basename,
    element: (
      <DefaultLayout>
        <Outlet />
      </DefaultLayout>
    ),
    children: [
      {
        path: '/',
        element: <Navigate to="section" replace />,
      },
      // NOTE: This is a quick fix for 404 when clicking on Campus Insights Beta
      // https://virdocs.atlassian.net/browse/BI-7470?atlOrigin=eyJpIjoiMWI0MjM2ZjlmYzBhNDgzNGE3YjE3ODZlYmU1ZWYxY2QiLCJwIjoiaiJ9
      {
        path: '/dashboard',
        element: <Navigate to="/" replace />,
      },
      {
        path: '/section',
        element: <Sections />,
      },
      {
        path: '/section/:sectionId',
        element: <Section />,
      },
      {
        path: '/participant',
        element: <Participants />,
      },
      {
        path: '/participant/:participantId',
        element: <Participant />,
      },
      {
        path: '/materials_summary',
        element: <MaterialsSummary />,
      },
      {
        path: '/utilization_summary',
        element: <UtilizationSummary />,
      },
      {
        path: '/404',
        element: <Error404 />,
      },
      {
        path: '/403',
        element: <Error403 />,
      },
      {
        path: '*',
        element: <Navigate to="404" />,
      },
    ],
  },
];

export default routes;
